/**
 * THE SWEEPS IN STEP (the perf overhaul, Stage 1). Stealth's beam crosses the app's ground, and an open rail panel
 * paints its own copy of that ground (it stands over the map). They used to share one inherited custom property,
 * `--beam-x`, animated on `.app` - which restyled every element on the page every frame (idle Stealth: 99% of a
 * laptop's main thread). Now each animates on its own (the ground a transform, the panel its own non-inherited
 * property), and this keeps them in phase: every sweep that starts is put on the document's clock, so two sweeps
 * that start at different moments still cross the screen together.
 *
 * Matched by name: CSS modules hash keyframe names, so the test is "contains `ground-sweep`".
 */
import { useEffect } from 'react';

const SWEEP = 'ground-sweep';

/**
 * Put every running sweep among `animations` at the clock's origin. A paused one is left alone: giving it a start
 * would set it playing, and reduced motion holds it still.
 */
export function inStep(animations) {
  for (const a of animations) {
    if (a.animationName?.includes(SWEEP) && a.playState === 'running') a.startTime = 0;
  }
}

/**
 * On any sweep's start - the ground's on entering Stealth, a panel's on opening - EVERY running sweep in step, not
 * only the one starting: one that began paused (reduced motion, later lifted) never starts again to be heard.
 */
function onStart(event) {
  if (event.animationName.includes(SWEEP)) inStep(document.getAnimations?.() ?? []);
}

export default function useSweepInStep() {
  useEffect(() => {
    document.addEventListener('animationstart', onStart);
    return () => document.removeEventListener('animationstart', onStart);
  }, []);
}
